module.exports = __webpack_public_path__ + "media/images/icons/account-9bf3242c5e346e38c73f700755d4a1c6.svg";